import noop from 'utils/noop';

export default function useIosAtt() {
  return noop;
}
